import { render, staticRenderFns } from "./TicketsGlobalSearch.vue?vue&type=template&id=a28772c2&scoped=true&"
import script from "./TicketsGlobalSearch.vue?vue&type=script&lang=ts&"
export * from "./TicketsGlobalSearch.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsGlobalSearch.vue?vue&type=style&index=0&id=a28772c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28772c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a28772c2')) {
      api.createRecord('a28772c2', component.options)
    } else {
      api.reload('a28772c2', component.options)
    }
    module.hot.accept("./TicketsGlobalSearch.vue?vue&type=template&id=a28772c2&scoped=true&", function () {
      api.rerender('a28772c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ticket/TicketsGlobalSearch.vue"
export default component.exports